import React, { useContext  } from "react";
import { useNavigate  } from 'react-router-dom';
//import ReactGA from 'react-ga4';
import Modal from "react-bootstrap/Modal";
import Lang from '../lang/translations';
import Button from 'react-bootstrap/Button'
import Context from '../context/context';






export default function PopupInfo(props) {
	
	const  context = useContext(Context)	
	let navigate = useNavigate();
	//var ga = ReactGA.ga();

	function ClickProfile(props){


			navigate('/user/'+props.angelprofile.id);
	
	}
	
	function ClickChat(props){

			navigate('/chats/'+props.angelprofile.id);
	
	}
	
	
  return (<div>{ props.angelprofile && (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
	  dialogClassName="popupinfo"
	  animation={false}
    >
      <Modal.Header closeButton>
  		<h4>{props.header} - {props.angelprofile.age} {Lang( {"w": "anni","page": "popupInfo"} )}</h4>
      </Modal.Header>
      <Modal.Body>
        <h4>{props.title}</h4>
		<img alt="" className="immagineRounded" src={props.imagesrc}/>
      </Modal.Body>
      <Modal.Footer>
		 <Button onClick={() => { ClickChat(props)}}><i className="fa fa-comments"/> {props.button1}</Button>
		 <Button onClick={() => { ClickProfile(props)}} variant="secondary"><i className="fa fa-female"/> {props.button2}</Button> 
		</Modal.Footer>
    </Modal>
  )} </div>

  );
}






